import { render } from "./InscricoesPessoa.vue?vue&type=template&id=5747ccb3&scoped=true&ts=true"
import script from "./InscricoesPessoa.vue?vue&type=script&lang=ts"
export * from "./InscricoesPessoa.vue?vue&type=script&lang=ts"

import "./InscricoesPessoa.vue?vue&type=style&index=0&id=5747ccb3&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5747ccb3"]])

export default __exports__